export const USER_ROLE = {
  ADMIN: 'admin',
  STAFF: 'staff',
  CLIENT: 'client',
} as const;

export type UserRole = (typeof USER_ROLE)[keyof typeof USER_ROLE];

export const PORTAL = {
  PUBLIC: 'public',
  ADMIN: 'admin',
} as const;

export type Portal = (typeof PORTAL)[keyof typeof PORTAL];

export type AuthState =
  | { status: 'anonymous' }
  | { status: 'authenticated'; session: StoredAuthSession };

export interface LoginRequestDto {
  userName: string;
  password: string;
}

export interface RefreshRequestDto {
  refreshToken: string;
  /** The session's (usually expired) access token; CK validates the pair. */
  accessToken: string;
}

export interface TokenPairDto {
  accessToken: string;
  refreshToken: string;
}

export interface LoginResponseDto extends TokenPairDto {
  userId: number;
  lastName: string;
  firstName: string;
  lastNameKana: string;
  firstNameKana: string;
  email: string | null;
  phoneNumber: string | null;
  contactMethod: number;
  lastLoginTime: string;
  /** Untyped on purpose: the value stays untrusted until narrowed against `UserRole`. */
  usuppuRole?: string | null;
}

export interface StoredAuthSession extends LoginResponseDto {
  role: UserRole;
}
